import { resetItemsDisplayOrder } from '../util.js';

class Page {
  constructor() {
    const data = arguments[0] || {};
    this.id = data.id || null;
    this.name = data.name || null;
    this.name_l10n = data.name_l10n || [];
    this.index = data.index || null;
    this.items = data.items || [];
    this.display_order = data.display_order || 0;
  }

  set name(name) {
    this._name = name;
  }

  get name() {
    if (this._name) {
      return this._name;
    } else {
      return 'Page ' + (this.index + 1);
    }
  }

  addItem(item) {
    this.items.push(item);
    resetItemsDisplayOrder(this.items);
  }

  insertItem(item, index) {
    this.items.splice(index, 0, item);
    resetItemsDisplayOrder(this.items);
  }
}

export default Page;
